import { useState } from "react";
import "./permission.scss";
import { Button, Flex, Modal, Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import ListRole from "./list.role";
import CreateAndEditRole from "./create-and-edit.role";
import { IRoleResult } from "../../interfaces/role";
import ListUser from "./list.user";
import { IUserResult } from "../../interfaces/user";
import CreateAndEditUser from "./create-and-edit.user";
import { useHasPermission } from "../../hooks/useHasPermission";
import { PERMISSIONS } from "../../constants/permission";
const PermissionPage: React.FC = () => {
  const defaultTabKey = "1";
  const [activeKey, setActiveKey] = useState(defaultTabKey);
  const [openModal, setOpenModal] = useState(false);
  const [titleModal, setTitleModal] = useState<string>("Add role");
  const [selectRole, setSelectRole] = useState<IRoleResult>();
  const [selectUser, setSelectUser] = useState<IUserResult>();
  const [okRoleTriggered, setOkRoleTriggered] = useState(true);
  const [okUserTriggered, setOkUserTriggered] = useState(true);
  const hasPermissionEditor = useHasPermission([PERMISSIONS.PERMISSION_EDITOR]);

  const onChange = (newActiveKey: string) => {
    if (newActiveKey === defaultTabKey) {
      setOkRoleTriggered(true);
    } else setOkUserTriggered(true);
    setActiveKey(newActiveKey);
  };

  const isDefaultTabKey = () => {
    return activeKey === defaultTabKey;
  };

  const handleCreate = () => {
    setTitleModal(isDefaultTabKey() ? "Add role" : "Add new user");
    setSelectRole(undefined);
    setSelectUser(undefined);
    setOpenModal(true);
  };

  const handleEditRole = (role: IRoleResult) => {
    setTitleModal("Edit role");
    setSelectRole(role);
    setOpenModal(true);
  };

  const handleEditUser = (user: IUserResult) => {
    setTitleModal("Edit user");
    setSelectUser(user);
    setOpenModal(true);
  };

  const initialItems = [
    {
      label: "Permission",
      children: (
        <ListRole
          onEditRole={handleEditRole}
          trigger={okRoleTriggered}
          onDoneTrigger={() => setOkRoleTriggered(false)}
        />
      ),
      key: defaultTabKey,
    },
    {
      label: "Users",
      children: (
        <ListUser
          onDoneTrigger={() => setOkUserTriggered(false)}
          onEditUser={handleEditUser}
          trigger={okUserTriggered}
        />
      ),
      key: "2",
    },
  ];

  return (
    <div className="page-permission">
      <Flex gap={16} justify="space-between" align="center">
        <h2 className="title-page">Permission</h2>
        {hasPermissionEditor && (
          <Button type="primary" onClick={handleCreate}>
            <FontAwesomeIcon icon={faPlus} /> Add{" "}
            {isDefaultTabKey() ? "role" : "user"}
          </Button>
        )}
      </Flex>
      <Tabs onChange={onChange} activeKey={activeKey} items={initialItems} destroyOnHidden />
      {openModal && (
        <Modal
          open={openModal}
          onCancel={() => setOpenModal(false)}
          footer={null}
          width={isDefaultTabKey() ? 560 : 660}
          title={titleModal}
        >
          {isDefaultTabKey() ? (
            <CreateAndEditRole
              onClose={(isTrigger) => {
                setOpenModal(false);
                if (isTrigger) {
                  setOkRoleTriggered((prev) => !prev);
                }
              }}
              detailRole={selectRole}
            />
          ) : (
            <CreateAndEditUser
              onClose={(isTrigger) => {
                setOpenModal(false);
                if (isTrigger) {
                  setOkUserTriggered((prev) => !prev);
                }
              }}
              detailUser={selectUser}
            />
          )}
        </Modal>
      )}
    </div>
  );
};

export default PermissionPage;
